export default __webpack_public_path__ + "static/media/nucleo-icons.d6a66724.ttf";